import { render, staticRenderFns } from "./SettingsList.vue?vue&type=template&id=12e08c29&scoped=true"
import script from "./SettingsList.vue?vue&type=script&lang=ts"
export * from "./SettingsList.vue?vue&type=script&lang=ts"
import style0 from "./SettingsList.vue?vue&type=style&index=0&id=12e08c29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e08c29",
  null
  
)

export default component.exports